import { render, staticRenderFns } from "./RepairServiceForm.vue?vue&type=template&id=72b8f226"
import script from "./RepairServiceForm.vue?vue&type=script&lang=js"
export * from "./RepairServiceForm.vue?vue&type=script&lang=js"
import style0 from "./RepairServiceForm.vue?vue&type=style&index=0&id=72b8f226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports